import React from 'react';
import { title } from './BrandingSectionTitle.module.scss';

export default function BrandingSectionTitle({ children }) {
  return <h2 className={title}>{children}</h2>;
}
